import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

import { useConnectExtensionViewportSize } from '../useConnectExtensionViewportSize';

type ExtensionSkeletonProps = {
	height?: number;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InlineSkeleton = styled.span({
	display: 'inline-block',
	backgroundColor: token('color.skeleton'),
	borderRadius: token('radius.medium'),
	minWidth: '50px',
	height: '35px',
	padding: token('space.050'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ExtensionSkeleton = styled.div<ExtensionSkeletonProps>({
	display: 'block',
	backgroundColor: token('color.skeleton'),
	borderRadius: token('radius.medium'),
	width: '100%',
	minWidth: '60px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ height }) => (height ? `${height}px` : '35px'),
	padding: token('space.050'),
	boxSizing: 'border-box',
});

export const LegacyMacroRendererShadow: FC<{ showSpinner?: boolean; node: any }> = ({
	showSpinner,
	node,
}) => {
	const { viewportHeight } = useConnectExtensionViewportSize(node);

	return node && node.type === 'inlineExtension' ? (
		<InlineSkeleton data-testid="ext-skeleton">
			{showSpinner && <Spinner size="small" />}
		</InlineSkeleton>
	) : (
		<ExtensionSkeleton
			data-testid="ext-skeleton"
			height={fg('confluence_connect_macro_preset_height') ? viewportHeight : undefined}
		>
			{showSpinner && <Spinner size="small" />}
		</ExtensionSkeleton>
	);
};
